// extracted by mini-css-extract-plugin
export var bound = "item-module--bound--57a9f";
export var description = "item-module--description--71923";
export var item = "item-module--item--0bd42";
export var show = "item-module--show--62645";
export var text = "item-module--text--d8773";
export var thumb = "item-module--thumb--0cc6c";
export var thumb_img = "item-module--thumb_img--63c89";
export var thumb_inner = "item-module--thumb_inner--5af5c";
export var update = "item-module--update--7d822";